import ToastComponent from 'components/Toast.vue'
const Socket = {}
Socket.install = function (Vue) {
  const ToastConstructor = Vue.extend(ToastComponent)
  const instance = new ToastConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  function webSocket (host, duration = 1500) {
    window.webSocket = new WebSocket(host)
    window.webSocket.onopen = evt => {
      console.log('webSocket连接成功')
    }
    window.webSocket.onmessage = evt => {
      let data = JSON.parse(evt.data)
      var types = JSON.parse(data.exp_info)
      instance.message = data.content
      if (types.type === 'return') {
        window.stores.commit('newStatus', {
          status: 0
        })
      } else if (types.type === 'rent') {
        window.stores.commit('newStatus', {
          status: 1
        })
        window.stores.commit('lockNo', types.lockNo)
        window.stores.commit('success', true)
      } else if (types.type === 'rent_reverse') {
        window.stores.commit('newStatus', {
          status: 0
        })
      }
      instance.visible = true
      setTimeout(() => {
        instance.visible = false
      }, duration)
    }
    window.webSocket.onerror = (evt, e) => {
    }
    window.webSocket.onclose = evt => {
    }
  }
  Vue.prototype.$webSocket = webSocket
}
export default Socket



// WEBPACK FOOTER //
// ./src/socket/socket.js